import { render, staticRenderFns } from "./PluginIcon.vue?vue&type=template&id=254428d5&"
import script from "./PluginIcon.vue?vue&type=script&lang=js&"
export * from "./PluginIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports